import Auth from "@/components/pages/auth/Index";

import LoginForm from "@/components/pages/auth/Login";

import Register from "@/components/pages/auth/register/Index";
import RegistrationCompleteEmail from "@/components/pages/auth/complete/Email";

import PasswordRemind from "@/components/pages/auth/password/remind/Index";
import PasswordReset from "@/components/pages/auth/password/Reset";
import ActivationEmail from "@/components/pages/auth/activate/Send";

import AccountLocked from "@/components/pages/auth/Locked";

import AuthLogout from "@/components/pages/auth/Logout";
import AuthActivate from "@/components/pages/auth/activate/Index";

import AuthTransfer from "@/components/pages/auth/transfer/Index";

import TwoFactorReset from "@/components/pages/auth/twoFactorReset/Index";

import * as pages from "./../pageNameConstants";

export default {
  path: "/auth",
  component: Auth,
  children: [
    {
      path: "",
      name: pages.AUTH_LOGIN,
      component: LoginForm
    },
    {
      path: "register",
      name: pages.AUTH_REGISTER,
      component: Register
    },
    {
      path: "register/complete",
      name: pages.AUTH_REGISTER_COMPLETE,
      component: RegistrationCompleteEmail
    },
    {
      path: "password/reminder",
      name: pages.AUTH_PASSWORD_REMINDER,
      component: PasswordRemind
    },
    {
      path: "password/reset/:id",
      name: pages.AUTH_PASSWORD_RESET,
      component: PasswordReset
    },
    {
      path: "activate/resend",
      name: pages.AUTH_ACTIVATION_EMAIL,
      component: ActivationEmail
    },
    {
      path: "transfer/:id",
      name: pages.AUTH_TRANSFER_ACCOUNT,
      component: AuthTransfer
    },
    {
      path: "locked",
      name: pages.AUTH_LOCKED,
      component: AccountLocked
    },
    {
      path: "logout",
      name: pages.AUTH_LOGOUT,
      component: AuthLogout
    },
    {
      path: "activate/:id",
      name: pages.AUTH_ACTIVATION,
      component: AuthActivate
    },
    {
      path: "two-factor/reset/:id",
      name: pages.AUTH_TWO_FACTOR_RESET,
      component: TwoFactorReset
    }
  ]
};
